import Common from '../../Common';
import { TemplateType } from '../../Enums';
import Field from './template/Field';
import Profiles from './template/Profiles';
import User from './template/User';
import UserSettings from './template/UserSettings';
import Value from './template/Value';

export interface CompanyTemplateBrowse {
	id: id
	pbx_company_id: id
	name: string
	added: string
	type: string
}

export type CompanyTemplate = CompanyTemplateBrowse & {
	description: string
	items: CompanyTemplateItem[]
}

export interface CompanyTemplateItem {
	id: id
	name: string
	surname: string
}

const Template = class extends Common {
	user: InstanceType<typeof User>;
	field: InstanceType<typeof Field>;
	value: InstanceType<typeof Value>;
	userSettings: InstanceType<typeof UserSettings>;
	profiles: InstanceType<typeof Profiles>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.user = new User(headers);
		this.field = new Field(headers);
		this.value = new Value(headers);
		this.userSettings = new UserSettings(headers);
		this.profiles = new Profiles(headers);
	}

	// @ts-expect-error please i just want to build this project
	async browse(companyId: id): CustomResponse<CompanyTemplateBrowse[]> {
		return this.get(`/company/${companyId}/template`);
	}

	// @ts-expect-error please i just want to build this project
	async read(companyId: id, templateId: id): CustomResponse<CompanyTemplate> {
		return this.get(`/company/${companyId}/template/${templateId}`);
	}

	async create(
		companyId: id,
		data: {
			name: string
			description: string
			type: TemplateType
		}
	) {
		return this.post(`/company/${companyId}/template`, data);
	}

	async update(
		companyId: id,
		templateId: id,
		data: {
			name: string
			description: string
			type: TemplateType
		}
	) {
		return this.patch(`/company/${companyId}/template/${templateId}`, data);
	}

	async delete(companyId: id, templateId: id) {
		return this.doDelete(`/company/${companyId}/template/${templateId}`);
	}
}

export default Template
